import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-html-view-dialog',
  templateUrl: './html-view-dialog.component.html',
  styleUrls: ['./html-view-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtmlViewDialogComponent {
  constructor(public dialogRef: MatDialogRef<HtmlViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
